import { TFunction } from 'i18next'

export const presentStringValidator =
  (fieldName: string, t: TFunction) =>
  (value: string | undefined): string | null =>
    !value
      ? t('admin.resources.general.errors.presentError', { fieldName })
      : null

export const presentNumberValidator =
  (fieldName: string, t: TFunction) =>
  (value: number | undefined): string | null =>
    value === undefined
      ? t('admin.resources.general.errors.presentError', { fieldName })
      : null

export const presentValidator =
  (fieldName: string, t: TFunction) =>
  (value: any): string | null =>
    !value
      ? t('admin.resources.general.errors.presentError', { fieldName })
      : null

const urlRegex = /^(http|https):\/\/[^ "]+$/

export const presentUrlValidator =
  (fieldName: string, t: TFunction) =>
  (value: string | null | undefined): string | null =>
    !value
      ? t('admin.resources.general.errors.presentError', { fieldName })
      : !urlRegex.test(value)
      ? t('admin.resources.general.errors.urlError', { fieldName })
      : null

export const optionalUrlValidator =
  (fieldName: string, t: TFunction) =>
  (value: string | null | undefined): string | null =>
    !value
      ? null
      : !urlRegex.test(value)
      ? t('admin.resources.general.errors.urlError', { fieldName })
      : null

const usernameRegex = /^[a-zA-Z0-9._-]+$/
export const validUsernameValidator =
  (fieldName: string, t: TFunction) =>
  (value: string | null | undefined): string | null =>
    !value
      ? t('admin.resources.general.errors.presentError', { fieldName })
      : !usernameRegex.test(value)
      ? t('admin.resources.general.errors.invalidUsernameError', { fieldName })
      : null

const phoneNumberRegex = /^[0-9]{10}$/
export const validPhoneNumberValidator =
  (fieldName: string, t: TFunction) =>
  (value: string | null | undefined): string | null =>
    !value
      ? null
      : !phoneNumberRegex.test(value)
      ? t('admin.resources.general.errors.invalidPhoneNumberError', {
          fieldName,
        })
      : null

export type Validator<Input> = {
  [Key in keyof Input]?: (value: Input[Key]) => string | null
}

export type Errors<Input> = Partial<Record<keyof Input, string>>

export const validate = <Input,>(
  validator: Validator<Input>,
  input: Input
): Errors<Input> => {
  const errors: Errors<Input> = {}

  const keys = Object.keys(validator) as (keyof Input)[]

  keys.forEach((key) => {
    const error = validator[key]?.(input[key])

    if (error) {
      errors[key] = error
    }
  })

  return errors
}

export const hasErrors = (errors: Errors<unknown>): boolean =>
  Object.keys(errors).length > 0
